import React from "react";

// export const reducer = (state: any, action: any) => {
//   const { key, values } = action;
//   if (!key) {
//     return { ...state, ...values };
//   }
//   return { ...state, [key]: values };
// };

export const initialState = {
  sidebar: {},
  hideHeader: false,
  loading: [],
  openHelp: false,
};

interface ContextProps {
  state: any;
  dispatch: ({ type }: { type: string }) => void;
}

export const VoAppContext = React.createContext({} as ContextProps);
